<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <!-- 选单 -->
      <el-dropdown style="margin-left: 4px">
        <el-button type="primary" :disabled="data.Status==2 || !canWrite">
          单据选择<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item
            class="dropdown-item"
            @click.native="getOrder"
          >
            采购订单
          </el-dropdown-item>

          <el-dropdown-item
            class="dropdown-item"
            @click.native="getPurchaseinOrder"
          >
            采购入库单
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click.native="save" :disabled="data.Status==2&&!is_orderUpdateStatus">保存</el-button>
      <el-button
        type="primary"
        @click.native="orderUpdate"
        :disabled="data.Status != 2 || !canWrite"
        >变更</el-button
      >
      <el-button type="primary" @click.native="orderDel" :disabled="!isSave||data.Status==2||!canWrite"
        >删除</el-button
      >
      <el-button
        type="primary"
        @click.native="orderReview"
        :disabled="!isSave||!canReview"
        >{{ ReviewName }}</el-button
      >
      <!-- 联查 -->
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave">
          联查<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="goJump(1)"
            >采购订单情况</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item" @click.native="goJump(2)"
            >采购入库单情况</el-dropdown-item
          >
          <!-- <el-dropdown-item class="dropdown-item"
            >采购需求分析情况</el-dropdown-item
          > -->
          <!-- <el-dropdown-item class="dropdown-item"
            >销售订单情况</el-dropdown-item
          > -->
          <!-- <el-dropdown-item class="dropdown-item">预测单情况</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="openPrint" :disabled="!isSave"
        >打印</el-button
      >
    </div>
    <el-form
      :inline="true"
      :model="data"
      :line-form="true"
      label-width="90px"
      ref="ruleForm"
      :rules="rules"
      status-icon
    >
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="DocDate" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            $commonJs.toDateString(data.DocDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.DocDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 190px"
            :clearable="false"
            @change="val=>previewNo(val)"
          />
        </el-form-item>
        <el-form-item label="单据编码:" prop="DocNo" label-width="90px">
          <span
            v-if="Mode == 0 || ReviewStatus"
            class="not-edit"
            style="min-width: 190px"
            >{{ data.DocNo }}</span
          >
          <el-input
            v-else
            v-model="data.DocNo"
            placeholder="请输入单据编码"
            style="min-width: 190px"
          />
        </el-form-item>
        <el-form-item label="业务类型:" label-width="90px" prop="BusinessTypeId">
          <span class="not-edit" style="width: 190px" v-if="ReviewStatus">{{
            data.BusinessType
          }}</span>
          <el-select
            v-else
            v-model="data.BusinessTypeId"
            style="width: 190px"
          >
            <el-option @click.native="BusinessChange(item)" v-for="(item) in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
          </el-select>
       
          <!-- <business-select v-model="data.BusinessTypeId" :params="{ Kind: '应收', SourceType: '收入单' }"
                  @change="onChange" /> -->
        </el-form-item>
        <!-- 业务类型 -->
        <el-form-item label="票据类型:" label-width="90px" prop="InvoiceTypeId">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.InvoiceTypeName
          }}
          </span>
          <invoice-select v-else  @getInvoiceTypeValue="getInvoiceType" v-model="data.InvoiceTypeId"></invoice-select>
        </el-form-item>
        <el-form-item label="供应商:" prop="TradeUnitId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.TradeUnitName
          }}</span>
          <!-- <select-input
            v-else
            placeholder="请选择供应商单位"
            :label="data.TradeUnitName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
            @clear="clearTradeUnit"
            :clearable="!isSelect"
            :disabled="isSelect"

          /> -->
          <el-select v-else v-model="data.TradeUnitId" filterable   
            placeholder="请选择供应商单位">
            <el-option
              v-for="item in tradeUnitList"
              :key="item.TradeUnitId"
              :value="item.TradeUnitId"
              :label="item.FullName"
              @click.native="setTradeunit(item)"
            ></el-option>
          </el-select>
          <!-- <el-select v-else v-model="data.TradeUnitId"  filterable style="width: 190px" @change="setTradeunit" >
            <el-option
              v-for="item in tradeUnitList"
              :key="item.TradeUnitId"
              :value="item.TradeUnitId"
              :label="item.FullName"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="付款方式:">
          <template v-if="ReviewStatus">
            <span class="not-edit" v-if="data.PayId === 1">全额定金</span>
            <span class="not-edit" v-if="data.PayId === 2">全额现结</span>
            <span class="not-edit" v-if="data.PayId === 3">限期付款</span>
            <span class="not-edit" v-if="data.PayId === 4">月结</span>
            <span class="not-edit" v-if="data.PayId === 5">其他</span>
          </template>
          <el-select v-else v-model="data.PayId" style="width: 190px">
            <!-- <el-option v-for="item in serviceList" :key="item.id" :value="item.id" :label="item.name"></el-option>
             -->
            <el-option :value="1" label="全额定金" />
            <el-option :value="2" label="全额现结" />
            <el-option :value="3" label="限期付款" />
            <el-option :value="4" label="月结" />
            <el-option :value="5" label="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款到期日:" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.ExpiringDate
          }}</span>
          <el-date-picker
            v-else
            v-model="data.ExpiringDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 190px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="现结金额:" label-width="90px" :prop="data.PayId === 2 ? 'ReceiptAmount' : ''"  v-if="canPrice">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.ReceiptAmount
          }}</span>
          <select-input
            v-else
            placeholder="请输入订金金额"
            v-model="data.ReceiptAmount"
            @click="openAmount"
            style="width: 190px"
            @clear="clear"
          />
          <!-- <el-input
            v-else
            type="text"
            v-model="data.ReceiptAmount"
            placeholder="请输入金额"
            style="width: 190px"
          ></el-input> -->
        </el-form-item>

        <el-form-item label="仓库:" label-width="90px" prop="WarehouseId">
          <span class="not-edit"  v-if="ReviewStatus">{{
            data.WarehouseName
          }}</span>
          <wms-select
            v-else
            v-model="data.WarehouseId"
            
          ></wms-select>
        </el-form-item>
        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="EmpId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.EmpName }}</span>
          <select-input
            v-else
            placeholder="请选择经办人"
            :label="data.EmpName"
            v-model="data.EmpId"
            @click="openEmp"
          />
        </el-form-item>
        <el-form-item label="金额汇总:" label-width="90px" v-if="canPrice">
          {{ tableAmountSum }}
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:" label-width="90px">
          {{ data.MakeEmpName }}
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" label-width="90px">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              style="width: 600px"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="margin: 0px 0 20px">
        <el-table
          border
          :data="tableList"
          class="tableList"
          :row-class-name="tableRowClassName"
          @row-click="addColumn"
          v-keymove="addList"
        >
           <insert-row @on-insert="onInsert" />
           
          
          <el-table-column align="left" label="存货编码" min-width="140px">
            <template slot-scope="{ row }">
              <span>{{ row.ProductNo }}</span>
            </template>
          </el-table-column>
           <el-table-column align="left" label="存货名称" min-width="120px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.ProductName }}</span>
              <account-select
                v-else
                v-model="row.ProductName"
                :source="DAccount"
                @select="onSelect($event, row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal"
                @inputText="inputText($event, row)"
                @click.native="resetFun"
                @currentPage="currentPage($event, row)"
                :pageType="true"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="规格型号">
            <template slot-scope="{ row }">
              <span>{{ row.ProductSpec }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="属性"
            prop="PropertyId"
            align="left"
            min-width="100"
            key="table1_6"
            v-if="tablePropertyShow"
          >
            <template slot-scope="{ row }">
              <span v-if="row.SourceOrderNo && !row.PropertyId">{{row.PropertyName || ""}}</span>
              <el-select
                v-else-if="row.UseProcess && !ReviewStatus"
                v-model="row.PropertyId"
                @change="changeProperty($event, row)"
              >
                <el-option
                  v-for="item in propertyList"
                  :key="item.PropertyId"
                  :label="item.PropertyName"
                  :value="item.PropertyId"
                ></el-option>
              </el-select>
              <span v-else>{{row.PropertyName || ""}}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="颜色" min-width="120px" key="columnColor">
            <template slot-scope="{ row, $index }">
              <span v-if="row.SourceOrderNo && !row.ColorId">{{row.ColorName || ""}}</span>
              <el-select
                v-else-if="row.UseColor && !ReviewStatus"
                v-model="row.ColorId"
                @change="changeColor(row, $index)"
              >
                <el-option
                  v-for="item in row.Colors"
                  :key="item.ColorId"
                  :value="item.ColorId"
                  :label="item.ColorName"
                />
              </el-select>
              <span v-else>{{ row.ColorName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="left" label="采购单位" min-width="120px">
            <template slot-scope="{ row,$index}">
              <el-select
             v-if="row.Units && row.Units.length > 0 && !ReviewStatus"
             v-model="row.PuUnitId"
           >
             <el-option
               v-for="item in row.Units"
               :key="item.UnitId"
               :value="item.UnitId"
               :label="item.UnitName"
               @click.native="compareSaUnit(item, row, $index)"
             ></el-option>
           </el-select>
           <span v-else>{{ row.PuUnitName}}</span>
            </template>
            <!--  -->
          </el-table-column>
          <el-table-column align="right" label="数量" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.PuQuantity) }}</span>
              <el-input
                v-else
                v-quantity:[option]="option"
                type="text"
                v-model="row.PuQuantity"
                @change="changeQuantity($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="单价"
            min-width="140px"
             v-if="canPrice"
          >
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.Price"
                :disabled="row.IsGift"
                @change="changePrice(row, $index)"
              >
                <el-button v-if="row.ProductName" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Amount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.Amount"
                :disabled="row.IsGift"
                @input="changeAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          
          <!-- <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.QuotedPrice }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.QuotedPrice"
                :disabled="row.IsGift"
                @change="changeQuotedPrice(row, $index)"
              >
              </el-input>
            </template>
          </el-table-column> -->
         
          <!-- <el-table-column align="right" label="可用量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity)) }}</span>
            </template>
          </el-table-column> -->
  
          <!-- <el-table-column align="center" label="条形码" min-width="140px">
            <template slot-scope="{ row }">
               <span>{{ row.name }}</span> 
              <vue-barcode
                v-if="row.ProductNo != ''"   
                :value="row.ProductNo"
                width="1"
                height="20"
                fontSize="10"
              ></vue-barcode>
            </template>
          </el-table-column>-->

          <!--  -->
          <!-- <el-table-column align="left" label="仓库">
            <template slot-scope="{ row }">
              <span>{{ row.WarehouseName }}</span>
            </template>
          </el-table-column> -->
   
          <!-- <el-table-column align="right" label="现存量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.StockQuantity)) }}</span>
            </template>
          </el-table-column> -->



          <el-table-column align="right" label="数量2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Quantity2) }}</span>
              <span v-else-if="row.UnitType==0"></span>
              <el-input
                v-else
                v-quantity:[option]="option"
                type="text"
                v-decimals
                v-model.number="row.Quantity2"
                @change="changeQuantity2($event,row, $index)"
                @blur="getChangeQuantity($event, row, $index)"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="计量单位2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select
                v-if="row.Units && row.Units.length > 0 && !ReviewStatus"
                v-model="row.UnitId2"
              >
                <el-option
                  v-for="item in row.Units"
                  :key="item.UnitId"
                  :value="item.UnitId"
                  :label="item.UnitName"
                  @click.native="compareUnitId(item, row, $index)"
                ></el-option>
              </el-select>
              <span v-else-if="row.UnitType==0"></span>
              <span v-else>{{ row.UnitName2 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="right" label="换算率">
            <template slot-scope="{ row, $index }">
              <span  v-if="(ReviewStatus || row.ChangeType==0) && row.UnitType==1">{{ row.Rate }}</span>
            <span v-else-if="row.UnitType==0"></span>
            <el-input 
              v-else  
              type="text"
              v-model="row.Rate"
              @input="RateChange($event, row, $index)"
            ></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="160" align="left" label="备注">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{
                row.Remark
              }}</span>
              <el-input
                v-else
                v-model="row.Remark"
                @change="editT(row)"
                placeholder="请输入备注"
              />
            </template>
          </el-table-column>
          <!--  -->
          <!-- <el-table-column align="right" label="单价2" v-if="canPrice">
            <template slot-scope="{ row }">
              <span>{{ row.Price2 }}</span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Discount }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.Discount"
                :disabled="row.IsGift"
                @input="changeDiscount(row, $index)"
              />
            </template>
          </el-table-column>
          <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
              <el-input
                v-else
                v-decimals
                v-limit:value="{ max: 100, min: 0 }"
                type="text"
                v-model.number="row.TaxRate"
                :disabled="row.IsGift"
                @input="changeTaxRate(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
         
          <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.TaxPrice"
                :disabled="row.IsGift"
                @input="changeTaxPrice(row, $index)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxLimit) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxLimit"
                :disabled="row.IsGift"
                @input="changeTaxLimit(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxAmount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxAmount"
                :disabled="row.IsGift"
                @input="changeTaxAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column> -->
          <!--  -->
          <!-- <el-table-column align="right" label="可抵扣税额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxAmount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxAmount"
                :disabled="row.IsGift"
                @input="changeTaxAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.DiscountAmount"
                :disabled="row.IsGift"
                @input="changeDiscountAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column> -->
          <!--  -->
          <!-- <el-table-column align="left" label="到货日期" min-width="180px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{
                $commonJs.toDateString(row.DeliveryDate)
              }}</span>
              <el-date-picker
                v-else
                v-model="row.DeliveryDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 140px"
                @change="changeDeliveryDate(row)"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" label="赠品">
            <template slot-scope="{ row }">
              <el-checkbox
                @change="changeIsGift($event, row)"
                v-model="row.IsGift"
                :disabled="ReviewStatus"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计入库数量"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.StockInQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计入库数量2"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.StockInQuantity2)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计开票数量"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.InvoiceQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计开票数量2"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.InvoiceQuantity2)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="累计核算数量"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.CostQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="普通退货数量"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.RefundQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            label="普通退货数量2"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.RefundQuantity2)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="canPrice"
            align="right"
            label="累计结款金额"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(row.SettlementAmount) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            label="价格策略类型"
            min-width="110px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.PriceType == 0">进货价</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单据" min-width="110px">
            <template slot-scope="{ row }">
              <span v-if="row.SourceType == 10">采购入库单</span>
              <span v-if="row.SourceType == 4">采购订单</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单号" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ row.SourceOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="采购订单号" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ row.PuOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="应收数量"> 
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ReceivableQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="应收数量2">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ReceivableQuantity2)) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="操作" fixed="right" v-if="!ReviewStatus">
            <template slot-scope="{ row, $index }">
              <el-button
                v-if="$permission.canWrite('/business/purchase/stockby')"
                type="text"
                @click.stop="delTableList(row, $index)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!--  -->
 
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 190px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 190px">
          {{ data.Status == 2 && updateCompareReviewDate ? data.UpdateEmpName : '' }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 190px">
          {{ data.Status == 2 && updateCompareReviewDate ? $commonJs.toDateString(data.UpdateDate) : '' }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <wms-dialog ref="wmsDialog" in-dialog selectable @select="setWms" />
    <emptor-select
      ref="emptorSelect"
      in-dialog
      selectable
      multiple
      @select-multiple="setOrderList"
    />
    <order-dialog ref="orderDialog"  @save="initerPrice"   in-dialog />
    <purchasein-select
    ref="purchaseinSelect"
    in-dialog
      selectable
      multiple
      @select-multiple="setpurchaseinList"
    ></purchasein-select>
    <print-dialog
      ref="printDialog"
      :columns="columns"
      :data="columnData"
      :form-data="formData"
    ></print-dialog>
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <amount-dialog ref="editDialog" @data="setPayData" @close-saved="reload" />
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import curdMixins from "@/mixins/trend/curd";
import empDialog from "@/components/personnel/result/record/listDialog";
import orderDialog from "@/components//business/purchase/inquiry/priceDialog";
import printDialog from "@/components/common/printDialog/printDialog";
import accountSelect from "@/components/business/purchase/select";

import saleList from "@/data/business/sales/sale/edit/list.json";
import optionMixins from "@/mixins/option";
import purchaseinSelect from "@/components/business/stock/purchaseinbound/listDialog";
import settle from "@/components/basedata/finance/settle/select";
import invoiceSelect from "@/components/basedata/finance/invoice/select";
import wmsSelect from "@/components/basedata/basedoc/wms/select";
import wmsDialog from "@/components/basedata/basedoc/wms/listDialog";
import emptorSelect from "@/components/business/purchase/emptor/listDialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import amountDialog from "@/components/business/purchase/stock/editDialog";
export default {
  name: "editStockby",
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialog,
    accountSelect,
    VueBarcode,
    printDialog,
    purchaseinSelect,
        // saleOrderSelect,
    // deliveryReleaseSelect,
    settle,
    invoiceSelect,
    wmsSelect,
    wmsDialog,
    // businessSelect,
    emptorSelect,
    tradeunitDialog,
    amountDialog,
  },
  data() {
    return {
      api: require("@/api/pu/puDoc").default,
      sourceTypeApi:require("@/api/ba/sourceType").default,
      businessTypeApi:require("@/api/ba/businessType").default,
      pdApi: require("@/api/ba/product").default,
      puOrderApi: require("@/api/pu/puOrder").default,
      apiWarehouse: require("@/api/ba/warehouse").default, 
      warehouseList: [],
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      transportApi: require("@/api/ba/transport").default,
      code_api: require("@/api/sy/serialCode").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      invoiceTypeApi: require("@/api/ba/invoiceType").default,
      propertyApi: require("@/api/ba/property").default,
      initDAccount: [],
      initTotal: 0,
      SourceTypeIdArr:[],
      tableColorShow:true,
      tablePropertyShow: true,
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      colorList: [],
      DAccount: [],
      deleteDateList:[],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      isSelect: false, //是否选单过
      data: {
        DocId: 0,
        DocType: 0,
        DocNo: "",
        DocDate:this.$commonJs.getToday(),
        TradeUnitId: null,
        TradeUnitName: "",
        WarehouseId: null,
        InvoiceAmount: 0,
        MinusEntry:0,
        Remark: "",
        Amount: 0,
        TaxAmount: 0,
        DisposeTax: 0,
        Status: 0,
        PayStatus: 0,
        MakeEmpId: 0,
        SourceType:null,
        // MakeDate: "",
        ReviewEmpId: 0,
        ReviewDate: "",
        // AddTime: "",
        EmpName: "",
        MakeEmpName: "",
        ReviewEmpName: "",
        BusinessTypeId: null,
        BusinessType:null,
        PayId: null,
        EmpId: 0,
        DpId: 0,
        ExpiringDate: "",
        TaxLimit: 0,
        ShowTax: 0,
        ReceiptAmount: 0,
        InStatus: 0,
        CompleteStatus: 0,
        ExecStatus: 0,
        CompletionDate: "",
        UpdateEmpId: 0,
        UpdateDate: "",
        InvoiceTypeId: null,
        InvoiceNo: "",
        Pays: [],
        Products: [],
        Status: 0,
      },
      isMainUnitId2: false,
      Mode: 0,
      isSave: false,
      tabPosition: "",
      reach: "联查",
      handledBy: "",
      preparedBy: "",
      IsGift: false,
      service: null,
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      businessTypeList: [],
      propertyList: [],
      currentRow: null,
      currentIndex: 0,
      rules: {
        DocNo: [
          { required: true, message: "单据编码不能为空", trigger: "blur" },
        ],
        TradeUnitId: [
          { required: true, message: "供应商不能为空", trigger: "change" },
        ],
        DocDate:[
        { required: true, message: "单据日期不能为空", trigger: "change" },
        ],
        BusinessTypeId: [
          { required: true, message: "业务类型不能为空", trigger: "change" },
        ],
        ReceiptAmount: [
          { required: true, message: "现结金额不能为空", trigger: "change" },
        ],
        InvoiceTypeId: [
        { required: true, message: "票据类型不能为空", trigger: "change" },
        ],
        WarehouseId: [
        { required: true, message: "仓库不能为空", trigger: "change" },
        ],
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true,
      },
    };
  },
  computed: {
    tableAmountSum(){
      let sum = 0;
      let length = this.tableList.length;
      for(let i = 0; i < length; ++i){
        sum = sum + parseFloat(this.tableList[i]?.Amount ?? 0)
      }
      sum = sum.toFixed(2);
      sum = this.$commonJs.toThousands(sum)
      return sum;
    },
    orderUpdateStatus() {
      return this.data.Status == 2 && !this.is_orderUpdateStatus ? true : false;
    },
    updateCompareReviewDate() {
      return this.$dayjs(this.data.UpdateDate).valueOf() >= this.$dayjs(this.data.ReviewDate).valueOf()
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    isLineAbort() {
      return this.data.DocId > 0 && this.data.Products.length > 0
        ? false
        : true;
    },
    ReviewStatus() {
      return this.data.Status == 2 ? true : false;
    },
    canPrice() {
      return this.$permission.canPrice("/business/purchase/stockby");
    },
    canWrite() {
      return this.$permission.canWrite("/business/purchase/stockby");
    },
    canReview() {
      return this.$permission.canReview("/business/purchase/stockby");
    },
  },

  mounted() {
    this.init();
  
    if (this.$route.params.isSave) this.isSave = true;
    if (this.$route.params.mode == "create" || !this.$route.params.mode) {
      this.createOrder();
    }
    
  }, 
  methods: {
    async goJump(index){
      let params={}
      switch(index){
        case 1:
        params.SourceDocId=this.data.DocId
        const res = await this.sourceTypeApi.info("进货单")
        
        params.SourceType=res.SourceTypeId
        this.$router.push({ name:'emptor',params:params})
        break;
        case 2:
        params.SourceDocId=this.data.DocId
        const res1 = await this.sourceTypeApi.info("进货单")
        params.SourceType=res1.SourceTypeId
        this.$router.push({ name:'purchaseinbound',params:params})
        break;
      }
    },
    BusinessChange(val){
      this.data.BusinessTypeId=val.BusinessTypeId
      this.data.MinusEntry=val.MinusEntry
      console.log("val",val);
      this.data.BusinessType=val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status){
      console.log(status,'status')
      if(status){
        this.tableList.forEach(
          (item,index)=>{
            if(item.ProductId > 0 && item.PuQuantity != null && item.PuQuantity !== ''){
              item.PuQuantity= item.PuQuantity > 0 ? 0-item.PuQuantity : item.PuQuantity;
              item.Quantity2= item.Quantity2 > 0 ? 0-item.Quantity2 : item.Quantity2;
              this.changeQuantity(item.PuQuantity,item,index)
            }
            
            // this.changeQuantity2(item.PuQuantity,item,index)  
          }
        )
      }else{
        this.tableList.forEach(
          (item,index)=>{

            if(item.ProductId > 0 && item.PuQuantity != null && item.PuQuantity !== ''){
              item.PuQuantity=Math.abs(item.PuQuantity)
              item.Quantity2=Math.abs(item.Quantity2)
              this.changeQuantity(item.PuQuantity,item,index)
            }
            
            // this.changeQuantity2(item.PuQuantity,item,index)  
          }
        )
      }
    },
    initerPrice(price){
      this.currentRow.Price = price;
      this.changePrice(this.currentRow, this.currentIndex)
    },
  
    clear(){
      let deleteDateList = this.data.Pays.filter(item => {
        return item.T !== 0;
      })     
      deleteDateList.forEach(item => {
        item.T = 2
      })
      this.setPayData([], deleteDateList)
    },

     onInsert(e){
      let {type, index} = e;

      this.interpolate(null, index, type)
      
    },
    interpolate(row, index,type=""){
      let o = {
        T: 0,
        DocProductId: 0,
        DocId: 0,
        SourceGoodsId: 0,
        BarCode: "",
        PuUnitId: 0,
        Discount: 0,
        TaxRate: 0,
        Price: 0,
        PuQuantity: 0,
        BatchNo: "",
        TaxAmount: 0,
        Amount: 0,
        // AddTime: "",
        UnitId2: 0,
        Quantity2: 0,
        WarehouseId: 0,
        StockInQuantity: 0,
        StockInQuantity2: 0,
        InvoiceQuantity: 0,
        InvoiceQuantity2: 0,
        CostQuantity: 0,
        RefundQuantity: 0,
        RefundQuantity2: 0,
        CdRefundQuantity: 0,
        CdRefundQuantity2: 0,
        PricingType: 0,
        SourceOrderId: 0,
        SourceOrderNo: "",
        PuOrderId: 0,
        PuOrderNo: "",
        StockQuantity: 0,
        ExistQuantity: 0,
        ReceivableQuantity: 0,
        ReceivableQuantity2: 0,
        DocNo: "",
        DocType: 0,
        DocDate: "",
        TradeUnitId: 0,
        SourceType: 0,
        IsGift: false,
        TaxLimit: 0,
        TaxPrice: 0,
        QuotedPrice: 0,
        SettlementAmount: 0,
        BaseQuantity: 0,
        SubQuantity: 0,
        TradeUnitNo: "",
        TradeUnitName: "",
        ColorId: 0,
        ColorName: "",
        Price2: 0,
        DeliveryDate: "",
        ProductId: 0,
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        WarehouseNo: "",
        WarehouseName: "",
        PropertyId: null,
        PropertyName: "",
      };
      if(type=="down"){
        index=index+1;
      }
      this.tableList.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableList));
      this.tableList = [];
      this.$nextTick(() => {
        
        this.tableList = copy;
      })
 
    },
    //采购入库单选单
    async setpurchaseinList(data){
      console.log("data", data);
      if(data.TradeUnitId){
        this.data.TradeUnitId = data.TradeUnitId;
        this.data.TradeUnitName = data.TradeUnitName;
      }
      data.List.forEach(item=> {
        delete item.AddTime
      })
      let Quantity = this.tableList.map((i) => i.ProductId);
      const res = await this.sourceTypeApi.info("采购入库单")
      let SourceType = res.SourceTypeId;//采购入库单
      let addList = [];
      addList = data.List.reduce((arr, item) => {
        console.log(Quantity,item.ProductId)
        if(item.PropertyId == 0) {
          item.PropertyId = null;
        }
        if(item.PropertyName == null) {
          item.PropertyName = ""
        }
        if (!Quantity.includes(item.ProductId)) {
          arr.push({
            Requirement: "",
            Discount:0,
            StockInQuantity: 0,
            TaxRate:0,
            StockInQuantity2: 0,
            InvoiceQuantity: 0,
            InvoiceQuantity2: 0,
            CostQuantity: 0,
            RefundQuantity: 0,
            RefundQuantity2: 0,
            CdRefundQuantity: 0,
            CdRefundQuantity2: 0,
            StockQuantity: 0,
            ExistQuantity: 0,
            ReceivableQuantity: 0,
            ReceivableQuantity2: 0,
            SettlementAmount: 0,
            ...item,
            Discount: 100,
            SourceType,
            WarehouseId :this.data.WarehouseId,
            WarehouseName : this.data.WarehouseName,
            DocProductId: 0,
            // SourceDtsId:item.
            SourceOrderId: item.DocId,
            SourceDtsId: item.DocProductId,
            SourceGoodsld: item.DocProductId,
            SourceOrderNo: item.DocNo,
            OrderProductId: 0,
            PackQuantity: item.Quantity,
            //  PuQuantity:item.ReQuantity,//数量
            //  Quantity2:item.ReQuantity2,//数量2
             PuQuantity:item.Quantity,//数量
             Quantity2:item.Quantity2,//数量2
             PuUnitId: item.UnitId,
            UnitId2:item.UnitId2,
            UnitName2: item.Unit2Name,
            QuotedPrice: item.Price,
            PuUnitName:item.UnitName,
            //PuUnitName UnitName
            //Price2     
            // Price2: item.ReQuantity2>0 ? parseFloat((item.Amount / item.ReQuantity2).toFixed(2)) : 0,
            Price2: item.Price2,
            PropertyId: item.PropertyId? item.PropertyId : 0,
            PropertyName: item.PropertyName,
            ColorId:item.ColorId,
            ColorName:item.ColorName
          });   
        }else{
         this.$message.warning("该产品已存在");
        }
        return arr;
      }, []);
      addList.forEach((item, i) => {
        item.ChangeType = 0;        
        item.UnitType = item.Units.length > 0?1:0;
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length > 0 && item.PuUnitId) {
          const findIndex = item.Units.findIndex(el => el.UnitId == item.PuUnitId)
          let  data=this.getUnitValue(item.Units,findIndex)
          item.IsMain=data.IsMain
          const IsMainIndex = item.Units.findIndex(el=>el.IsMain==true) //主单位的索引
          const UnitId2Index = item.Units.findIndex(el=>el.UnitId==item.UnitId2) //不是主单位的索引 
          const noMainIndex = item.Units.findIndex(el=>el.IsMain==false)
          if(findIndex==IsMainIndex){ //判断当前销售单位是否为主单位
            item.Rate=item.Units[UnitId2Index != -1?UnitId2Index:noMainIndex].Rate || 0
            item.ChangeType=item.Units[UnitId2Index != -1?UnitId2Index:noMainIndex].ChangeType || 0
          }else{
            //如果当前是赋单位
            item.Rate=item.Units[findIndex].Rate   
            item.ChangeType=item.Units[findIndex].ChangeType
          }

          this.changeQuantity(item.PuQuantity,item,i)
        } else {
          item.Units.forEach(v=>{
            if(v.ChangeType==1)item.ChangeType=v.ChangeType
          })
        }
      })
      console.log("addList",addList);
      
      let tableData = JSON.parse(JSON.stringify(this.tableList));
      this.tableList = [];
      tableData = tableData.filter(item => item.ProductId !== 0 && item.ProductId != null);
      console.log('tableData', tableData)
      
      let arr = [];
      arr.push(...addList)
      arr.push(...tableData)


      this.$nextTick(() => {
        this.tableList = arr;
      })
     


      

      if(this.data.TradeUnitId){
        this.isSelect = true;
      }
    },
    
    getInvoiceType(value){
      console.log(value,'value')
      for(let i=0;i<value.length;i++){
        if(value[i].InvoiceTypeName=='收据'){
          this.data.InvoiceTypeName=value[i].InvoiceTypeName
          this.data.InvoiceTypeId=value[i].InvoiceTypeId
          return
        }else{
         this.data.InvoiceTypeName=value[0].InvoiceTypeName
          this.data.InvoiceTypeId=value[0].InvoiceTypeId
        }
      } 

    },
    setPayData(data,deleteDateList) {
      this.data.Pays = data 
      this.deleteDateList=deleteDateList
      // console.log('data',data);
      this.data.ReceiptAmount = data
        .map((i) => i.PayAmount)
        .reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      // this.data.ReceiptAmount = 30;

      console.log("Amount", this.data.ReceiptAmount);
    },
    openAmount() {
      this.$refs.editDialog.open().then(that => {
        that.setMinusEntry(this.data.MinusEntry)
        
      })
    },
    openWarehouse() {
      this.$refs.wmsDialog.open().then((that) => {
        that.getData();
      });
    },
    setWms(data) {
      // console.log("data", data);
      this.data.WarehouseId = data.WarehouseId;
      this.data.WarehouseName = data.WarehouseName;
      this.tableList.forEach(e => {
        if(e.WarehouseId != data.WarehouseId) {
          e.T = e.T===0?0:1;
          e.WarehouseId = data.WarehouseId;
          e.WarehouseName = data.WarehouseName;
        }
      })
    },
    openTradeunit() {
      if(!this.isSelect){
        this.$refs.tradeunitDialog.open().then((that) => {
          that.getData({ TradeUnitTypes: [1, 2] });
          // that.getData();
        });
      }
      
    },
    clearTradeUnit(){
      this.data.TradeUnitId = null;
      this.data.TradeUnitName = "";
      this.data.TradeUnitType = -1;
    },
    async getOrder() {
      // this.$refs.emptorSelect.open();
      let TradeUnitId = this.data.TradeUnitId;
      const res = await this.sourceTypeApi.info("进货单")
        
      let OrderType = res.SourceTypeId
      let that = await this.$refs.emptorSelect.open();
      that.getData({ Status: 2, TradeUnitId, LineAbort: false, OrderType });
    },
    async getPurchaseinOrder(){
      let TradeUnitId = this.data.TradeUnitId;
      const res = await this.sourceTypeApi.info("进货单")
      let OrderType = res.SourceTypeId

      let that = await this.$refs.purchaseinSelect.open();
      that.setBypeId(this.data.BusinessTypeId)
      that.getData({ Status: 2, TradeUnitId, OrderType, BusinessTypeId: this.data.BusinessTypeId });
    },
    previewNo(val='') {
      this.code_api.previewNo("进货单",val).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取进货单编码失败");
        }
      });
    },
   
    init() {
      this.callOptionApi();
      // this.apiWarehouse.list({pageIndex: 1,pageSize: 10}).then((res)=>{
      //   if (res.Code == 0){
      //     this.warehouseList = res.Data
      //   }
      // })
      this.sourceTypeApi.list({}).then(res=>{
        if(res.Code==0) {
          this.SourceTypeIdArr=res.Data
          let params="进货单"
          let index=  this.SourceTypeIdArr.findIndex(item=>item.SourceType==params)
          let SourceTypeId =this.SourceTypeIdArr[index].SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res=>{
            if(res.Code==0){
              this.businessTypeList=res.Data
              this.data.BusinessTypeId=this.businessTypeList[0].BusinessTypeId
              console.log("businessTypeList",this.businessTypeList);
              this.data.BusinessType=this.businessTypeList[0].BusinessType
              this.data.MinusEntry=this.businessTypeList[0].MinusEntry
              console.log("this.data",this.data);
              this.changeNumber(this.data.MinusEntry)
            }
          })
        }
        console.log("触发编辑");
        console.log('this.$route.params===========', this.$route.params)
        if (this.$route.params.mode == "edit") {
          this.editOrder(this.$route.params.data.DocId);
        }
        if (this.$route.params.mode == "details") {
          this.editOrder(this.$route.params.data.DocId);
        }
      })
      this.tradeUnitApi.list({ TradeUnitTypes: [1,2,3] ,Status:1}).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });
      this.transportApi.list({}).then((res) => {
        if (res.Code == 0) this.transportList = res.Data;
      });
      this.pdApi.list({ Property: "采购" , pageIndex: 1,pageSize: 7, Status: 1,}).then((res) => {
        this.DAccount = res.Data;
        this.initDAccount = res.Data;
        this.listTotal = res.Count;
        this.initTotal = res.Count;
      });
      this.invoiceTypeApi.list({Status:1}).then((res)=>{
        if(res.Code==0){
          res.Data.forEach((item)=>{
        if(item.InvoiceTypeName=="收据"){
              this.data.InvoiceTypeName=item.InvoiceTypeName
              this.data.InvoiceTypeId=item.InvoiceTypeId
              return;
            }    
          })
        }

      })
      this.propertyApi.list({
        Status: 1,
      })
      .then((res) => {
        if (res.Code === 0) {
          this.propertyList = res.Data;
        }
      });
    },
    createOrder() {
        const user = this.$store.state.user;
        if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
        this.data.MakeEmpId = user.id;
        this.data.MakeEmpName = user.name;
      }
      this.addList();
      this.previewNo();
    },     
    editOrder(data, type = 0) {
      console.log("执行编辑", data);
      this.api.info(data).then((res) => {
        if (res.Code === 0) {
          this.isSave = true;
          res.Data.Pays?.map((i) => ((i.T = null), i));
          this.data = res.Data;
          this.tableList = res.Data.Products?.map(
            (item) => ((item.T = 3), item)
          );
          console.log("businessTypeId",res.Data.BusinessTypeId)
          console.log("this.businessTypeList",this.businessTypeList)
         var businessType= this.businessTypeList.filter((x)=>{ return x.BusinessTypeId==res.Data.BusinessTypeId;})[0];
          console.log("businessType",businessType);
         this.data.BusinessType=businessType.BusinessType;
         this.data.BusinessTypeId=businessType.BusinessTypeId;
         this.data.MinusEntry=businessType.MinusEntry;
         console.log("businessType",businessType);
         if(this.data.MinusEntry){
            this.tableList.forEach(
              (item,index)=>{
                item.PuQuantity= item.PuQuantity > 0 ? 0-item.PuQuantity : item.PuQuantity;
                item.Quantity2= item.Quantity2 > 0 ? 0-item.Quantity2 : item.Quantity2;
              }
            )
          }else{
            this.tableList.forEach(
              (item,index)=>{
                item.PuQuantity=Math.abs(item.PuQuantity)
                item.Quantity2=Math.abs(item.Quantity2)
              }
            )
          }
          this.tableList.forEach(item => {
            if(item.Units.length === 0){
              item.UnitType = 0
            }else{
              item.UnitType = 1
              let UnitItem = item.Units.filter((v) => {
                return item.PuUnitId === v.UnitId;
              })[0];
              console.log('UnitItem', UnitItem)

              item.IsMain = UnitItem.IsMain;
              item.ChangeType = 0;
              item.Units.forEach(v=>{
                if(v.ChangeType==1)item.ChangeType=v.ChangeType
              })
             
            }
          })

          if(type === 1){
            this.Review()
          }
        }
        if (res.Data.Products.length == 0) this.addList();
      });
    },
    toggleOrder() {
      this.$refs.saleQuotationSelect.open();
    },

    async setOrderList(data) {
      console.log("data", data);
       if(data.TradeUnitId){
        this.data.TradeUnitId = data.TradeUnitId;
        this.data.TradeUnitName = data.TradeUnitName;
      }
      this.data.InvoiceTypeId=  data.InvoiceTypeId;
      this.data.InvoiceTypeName = data.InvoiceTypeName;
      this.data.PayId= data.PayId;
      this.data.PayName= data.PayName;

      let Quantity = this.tableList.map((i) => i.ProductId);
      
      const res = await this.sourceTypeApi.info("采购订单")
      let SourceType = res.SourceTypeId;//采购订单
      let addList = [];
      // data.List[0].SourceType==''? SourceType=1 :SourceType=0
      addList = data.List.reduce((arr, item) => {   
        console.log('====item====', item, item.PuUnitId)
        if (!Quantity.includes(item.ProductId)) {
          let UnitType = 0;
          if (item.Units.length != 0) {
            UnitType = 1;
          }
          arr.push({
            Requirement: "",
            StockInQuantity: 0,
            StockInQuantity2: 0,
            InvoiceQuantity: 0,
            InvoiceQuantity2: 0,
            CostQuantity: 0,
            RefundQuantity: 0,
            RefundQuantity2: 0,
            CdRefundQuantity: 0,
            CdRefundQuantity2: 0,
            StockQuantity: 0,
            ExistQuantity: 0,
            ReceivableQuantity: 0,
            ReceivableQuantity2: 0,
            SettlementAmount: 0,
            WarehouseId :this.data.WarehouseId,
            WarehouseName : this.data.WarehouseName,
            ...item,
            SourceType,
            PuQuantity: item.PurchaseQuantity,
            // SourceDtsId:item.
            SourceOrderId: item.OrderId,
            SourceDtsId: item.OrderProductId,
            SourceGoodsId: item.OrderProductId,
            SourceOrderNo: data.Order,
            OrderProductId: 0,
            PackQuantity: item.Quantity,
            PuUnitId: item.PuUnitId,
            PuUnitName: item.PuUnitName ?? item.UnitName,
            UnitName2: item.Unit2Name,
            QuotedPrice: item.Offer,
            Price2: item.Quantity2 > 0 ? parseFloat((item.Amount / item.Quantity2 ).toFixed(2)) : 0,
            PropertyId: item.PropertyId? item.PropertyId : 0,
            PropertyName: item.PropertyName,
            ColorId:item.ColorId,
            ColorName:item.ColorName,
            UnitType: UnitType
          });
        }else{
         this.$message.warning("该产品已存在");
        }
        return arr;
      }, []);
      console.log('addList', addList)
      addList.forEach((item, i) => {
        item.ChangeType = 0;
        item.UnitType = item.Units.length > 0?1:0;
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length > 0 && item.PuUnitId) {
          const findIndex = item.Units.findIndex(el => el.UnitId == item.PuUnitId)
          let  data=this.getUnitValue(item.Units,findIndex)
          item.IsMain=data.IsMain
          const IsMainIndex = item.Units.findIndex(el=>el.IsMain==true) //主单位的索引
          const UnitId2Index = item.Units.findIndex(el=>el.UnitId==item.UnitId2) //不是主单位的索引 
          const noMainIndex = item.Units.findIndex(el=>el.IsMain==false)
          if(findIndex==IsMainIndex){ //判断当前销售单位是否为主单位
            item.Rate=item.Units[UnitId2Index != -1?UnitId2Index:noMainIndex].Rate || 0
            item.ChangeType=item.Units[UnitId2Index != -1?UnitId2Index:noMainIndex].ChangeType || 0
            item.IsMain=true;
          }else{
            //如果当前是赋单位
            item.Rate=item.Units[findIndex].Rate   
            item.ChangeType=item.Units[findIndex].ChangeType
            item.IsMain = false;
          }

          this.changeQuantity(item.PuQuantity,item,i)
        } else {
          item.Units.forEach(v=>{
            if(v.ChangeType==1)item.ChangeType=v.ChangeType
          })
        }
      })
      this.tableList.unshift(...addList);
      console.log('this.tableList', this.tableList)
      if(this.data.TradeUnitId){
        this.isSelect = true;
      }
    },

    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({val, text1}, row) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({  Property: "采购", pageIndex: val, pageSize: 7, Status: 1, ProductName:text1})
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.ProductName = text;
      this.pdApi
        .list({
          Property: "采购",
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    setProduct(row, index) {
      let data = this.productList.filter(
        (item) => item.ProductId === row.ProductId
      );
      this.tableList[index].ProductName = data[0].ProductName;
      this.tableList[index].ProductNo = data[0].ProductNo;
      this.tableList[index].ProductSpec = data[0].ProductSpec;
      this.tableList[index].PuUnitName = data[0].PuUnitName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      
      if(this.data.WarehouseId==0 || this.data.WarehouseId==null) return this.$message.warning("请先选择仓库");
      if (row.SourceOrderNo && row.ProductId != e.ProductId) {
        // this.data.TradeUnitId = '';
        // this.$nextTick(() => {
        //   this.$refs.ruleForm.clearValidate();
        // })
        row.SourceOrderId = 0
        row.SourceDtsId = 0
        row.SourceOrderNo = ''
        row.SourceType = 0

      }
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1;
      row.WarehouseId = e.WarehouseId;
      row.WarehouseCode = e.WarehouseCode;
      row.WarehouseName = e.WarehouseName;
      row.ProductNo = e.ProductNo;
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.PuUnitId = e.PuUnitId;
      row.PuUnitName = e.PuUnitName;
      row.UnitId2 = e.UnitId2;
      row.ColorId = null;
      row.UnitType=0;
      row.ChangeType=0;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;
      // this.colorList = e.Colors;
      // this.optionList = e.Units;
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.WarehouseId =this.data.WarehouseId;
      row.WarehouseName = this.data.WarehouseName;
      if (!Number(row.PuQuantity)) row.PuQuantity = 0;
      // if (e.UnitType === 0) {
      //   row.UnitId2 = e.PuUnitId;
      //   row.UnitName2 = e.PuUnitName;
      // }

      //
      if (e.Units.length === 0) {
        row.PuUnitName = e.PuUnitName;
        row.UnitName = e.PuUnitName;
        row.UnitId2 =0;
        row.SaUnitName = e.SaUnitName;
        row.UnitName2 ='';  
        row.Rate = 0;
        row.Quantity2=0;
      }else{
        row.UnitType=1
        e.Units.forEach(item=>{
          if(item.ChangeType==1)row.ChangeType=item.ChangeType
        })
        if(row.PuUnitId){
          let index = this.getUnitIndex(3,e.Units,row.PuUnitId)
          let  data=this.getUnitValue(e.Units,index)
          let assistIndex=0
          let assistData={}
          row.IsMain=data.IsMain
         
          if(data.IsMain){
          assistIndex= this.getUnitIndex(2,e.Units)
          assistData=this.getUnitValue(e.Units,assistIndex)
          row.Rate= this.getIinvexchrate(assistData.Rate);
          }else{
          assistIndex= this.getUnitIndex(1,e.Units)
          assistData=this.getUnitValue(e.Units,assistIndex)
          row.Rate= this.getIinvexchrate(data.Rate); 
          }
          row.UnitId2=assistData.UnitId
          row.UnitName2=assistData.UnitName
        }else{
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for(let i = 0; i < untiLength; ++i){
            if(e.Units[i].IsMain){
              mainData.push(e.Units[i])
            }else{
              noMainData.push(e.Units[i])
            }
          }
          row.PuUnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = this.getIinvexchrate(noMainData[0].Rate);
          row.IsMain = true;
        }
      
      
      }
      // if (e.Units.length > 0) {
      //   const UnitIds = e.Units.map((i) => i.UnitId);
      //   const index =
      //     UnitIds.indexOf(e.PuUnitId) === e.Units.length
      //       ? 0
      //       : UnitIds.indexOf(e.PuUnitId) + 1;
      //   // row.UnitId2 = UnitIds[index];
      //   const saleData = e.Units.filter((i) => i.UnitId === e.PuUnitId)[0];
      //   const unitData = e.Units.filter((i) => i.UnitId === UnitIds[index])[0];
      //   // row.Rate = unitData.Rate / saleData.Rate;
      //   // row.Quantity2 = (row.PuQuantity / row.Rate).toFixed(2);
      //   row.UnitChangeType = unitData.ChangeType;
      // }
      let _colorShow=this.tableList.find(item=>item.UseColor==true)
     if(_colorShow){
      this.tableColorShow=true
     }else{
      this.tableColorShow=false
     }
    // let _propertyShow=this.tableList.find(item=>item.UseProcess==true)
    //  if(_propertyShow){
    //   this.tablePropertyShow=true
    //  }else{
    //   this.tablePropertyShow=false
    //  }

     
      this.api
        .productPrice({
          TradeUnitId: this.data.TradeUnitId ?? 0,
          ProductId: e.ProductId,
        })
        .then((res) => {
          if (res.Data) {
            row.SalePrice = res.Data.SalePrice;
            row.RetailPrice = res.Data.RetailPrice;
            row.PurchasePrice = res.Data.PurchasePrice;
            row.SaCostPrice = res.Data.SaCostPrice;
            row.QuotedPrice = res.Data.PurchasePrice;
            row.Price = res.Data.PurchasePrice;
            row.TaxPrice = res.Data.PurchasePrice;
          }
        });
    },
    RateChange(data,row,index){
      if (data < 0|| data=='') return;
      this.$set(this.tableList[index],"Rate",data)

      if (row.T === 3) row.T = 1;    
      this.changeQuantity(this.tableList[index].PuQuantity,row,index)   
   
    },
    compareSaUnit(data, row, index) { 

      if (row.T === 3) row.T = 1;    
      this.tableList[index].IsMain=data.IsMain 
      let  findIndex=0
      if(row.PuUnitId==row.UnitId2){
        let num =0
        num=row.PuQuantity
        row.PuQuantity=row.Quantity2
        row.Quantity2=num
        if(data.IsMain){
          //当前选择的主单位
           findIndex =this.getUnitIndex(2,this.tableList[index].Units)
          this.changeRightUnitId(index,findIndex)
        }else{
           findIndex =this.getUnitIndex(1,this.tableList[index].Units)
          this.changeRightUnitId(index,findIndex)
        }
      }else{
          if(data.IsMain){
            findIndex =this.getUnitIndex(2,this.tableList[index].Units)
            this.changeRightUnitId(index,findIndex)
          }else{
            findIndex =this.getUnitIndex(1,this.tableList[index].Units)
            this.changeRightUnitId(index,findIndex,data.Rate)        
          }
      }
      this.changeQuantity(this.tableList[index].PuQuantity,row,index)
    },
      //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index,findIndex,Rate=0){
        this.tableList[index].UnitId2=this.tableList[index].Units[findIndex].UnitId
        this.tableList[index].UnitName2=this.tableList[index].Units[findIndex].UnitName 
        if(Rate>0){
          this.tableList[index].Rate=  this.getIinvexchrate(Rate) 
        }
    },
    changeQuantity2(data, row, index){
      if(data=='-' || data== '.' || data==''){
          return
      }
      data = Number(this.getQuantity(data))
      row.PuQuantity = data;
      if(this.data.MinusEntry){
            row.PuQuantity > 0 ? row.PuQuantity=0-row.PuQuantity  :  row.PuQuantity
            row.Quantity2 > 0 ? row.Quantity2=0-row.Quantity2 : row.Quantity2;
            data = data > 0 ? 0 - data : data;
      }else{
             row.PuQuantity=Math.abs(row.PuQuantity) 
            row.Quantity2=Math.abs(row.Quantity2) 
            data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1;
        if(row.IsMain==false){  
            if(row.ChangeType==1 ){ 
              if (row.PuQuantity === '' || row.PuQuantity === 0) {
                return;
              }
              row.Rate= this.getIinvexchrate(data/row.PuQuantity);
            }else{
              console.log("数量1=数量2/换算率")
              row.PuQuantity= this.getQuantity(data/row.Rate);
            }
          }else{
            if(row.ChangeType==1){
              if (row.PuQuantity === '' || row.PuQuantity === 0) {
                return;
              }
               row.Rate= this.getIinvexchrate(row.PuQuantity/data);       
            }else{
              console.log("数量1=数量2*换算率") 
             row.PuQuantity= this.getQuantity(data*row.Rate);
            }

          }
             
    },
    getUnitValue(arr,findIndex){
      let data={}
      data.UnitId=arr[findIndex].UnitId
      data.UnitName=arr[findIndex].UnitName
      data.IsMain=arr[findIndex].IsMain 
      data.ChangeType=arr[findIndex].ChangeType
      data.Rate=arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引 
    getUnitIndex(type,arr,id=''){
      let index=0
      if(type==1){
        //获取主单位索引
         index = arr.findIndex(el=>el.IsMain==true)
      }else if(type==2){
        //获取数组第一个不是主单位的索引
         index = arr.findIndex(el=>el.IsMain==false)
      }else{
        //获取当前传入id的索引
        index= arr.findIndex(el=>id==el.UnitId)
      }
      return index
    },
    changeLeftUnitId(index,findIndex,Rate=0){
        this.tableList[index].PuUnitId=this.tableList[index].Units[findIndex].UnitId
        this.tableList[index].SaUnitName=this.tableList[index].Units[findIndex].UnitName 
        if(Rate>0){
          this.tableList[index].Rate= this.getIinvexchrate(Rate)
        }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;
      if(data.IsMain){
        this.tableList[index].IsMain=false
      }else{
        this.tableList[index].IsMain=true
      }
      let  findIndex=0
      if(row.PuUnitId==row.UnitId2){
        console.log(row.PuUnitId,'row.PuUnitId')
        let num =0
        num=row.PuQuantity
        row.PuQuantity=row.Quantity2
        row.Quantity2=num
        if(this.tableList[index].IsMain==false){
          //当前选择的主单位
           findIndex =this.getUnitIndex(2,this.tableList[index].Units)
          this.changeLeftUnitId(index,findIndex)
        }else{
           findIndex =this.getUnitIndex(1,this.tableList[index].Units)
          this.changeLeftUnitId(index,findIndex)
        }
      }else{
        if(this.tableList[index].IsMain==false){
          //当前选择的主单位
           findIndex =this.getUnitIndex(2,this.tableList[index].Units)
          this.changeLeftUnitId(index,findIndex)
        }else{
           findIndex =this.getUnitIndex(1,this.tableList[index].Units)
          this.changeLeftUnitId(index,findIndex,data.Rate)
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2,row,index)

    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList();
      }
    },
    // compareUnitId(data, row, index) {
    //   console.log("data", data);

    //   this.isMainUnitId2 = true;
    //   this.tableList[index].Rate = data.UnitId === row.PuUnitId ? 1 : data.Rate;
    //   row.UnitChangeType = data.ChangeType;
    //   if (data.ChangeType === 0) row.Quantity2 = row.PuQuantity * row.Rate;
    //   if (data.ChangeType === 1 && Number(row.Quantity2) != 0)
    //     row.Rate = row.Quantity2 / row.PuQuantity;
    // },
    changeDeliveryDate(row) {
      if (row.T === 3) row.T = 1;
    },
    changeIsGift(data, row) {
      if (row.T === 3) row.T = 1;
      if (data) {
        row.QuotedPrice = 0;
        row.Discount = 0;
        row.TaxRate = 0;
        row.Price = 0;
        row.TaxPrice = 0;
        row.Amount = 0;
        row.TaxLimit = 0;
        row.TaxAmount = 0;
        row.DiscountAmount = 0; 
      }
    },  
    RestartOrder() {
      this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
      this.createOrder();
      // this.addList();

      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 30);
    },

    orderUpdate() {
      this.$message.success("变更");
      this.is_orderUpdateStatus = true;
    },
    Review(){
      this.api.review(this.data.DocId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.editOrder(this.data.DocId);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "back" : "review";
          if(data === 'review'){
            this.save(1);
          }else if(data === 'back'){
            this.api[data](this.data.DocId).then((res) => {
              if (res.Code === 0 && data == "review") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "back") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.editOrder(this.data.DocId);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.DocId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    delTableList(data, index) {
      // if (data.SourceOrderNo) {
      //   this.data.TradeUnitId = '';
      //   this.$nextTick(() => {
      //     this.$refs.ruleForm.clearValidate();
      //   })
      // }
      // this.$message.success("删除");
      this.tableList.splice(index, 1);
      if (this.tableList.length === 0) {
        this.addList();
      }


      let pds = this.tableList.filter(item => {
        return item.ProductId !== 0
      })
      if(pds.length === 0){
        this.isSelect = false;
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
      this.data.DpId = data.DpId;
      this.data.DpName = data.DpName;
      this.data.DpNo = data.DpNo;
    },
    openSales(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      let ProductName = row.ProductName;
      console.log('this.data', this.data)
      let TradeUnitName = this.data.TradeUnitName;

      this.$refs.orderDialog.open().then(that => {
        that.setData(ProductName, TradeUnitName);
      })
    },

    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
      this.data.TradeUnitType = data.TradeUnitType;
      console.log("data",data)
      if(data.TradeUnitId){
        this.tradeUnitApi.info(data.TradeUnitId).then((res)=>{
          if(res.Code==0){
            if(res.Data.PaymentSet){
                if(res.Data.PaymentSet.InvoiceType>0){
                    this.data.InvoiceTypeId=res.Data.PaymentSet.InvoiceType
                }else{
                  this.data.InvoiceTypeId=null
                }
                if(res.Data.PaymentSet.PaymentType>0){
                    this.data.PayId=res.Data.PaymentSet.PaymentType;
                }else{
                  
                  this.data.PayId=null
                }
            }
          }

        })
      }
    },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.DocId == 0 || row.OrderProductId == 0)
        row.LineAbort = false;
      this.api
        .lineAbort({
          Id: row.OrderProductId,
          IsLineAbort: data,
        })
        .then((res) => {
          if (res.Code === 1) {
            row.LineAbort = !data;
            return this.$message.error(res.Msg);
          }
        });
    },
    openDialog(type) {
      if (type === "销售订单") {
        this.title = "销售订单";
        this.bool = true;
        this.$refs.saleOrderSelect.open();
      } else {
        this.title = "销货单列表";
        this.bool = false;
        this.$refs.deliveryReleaseSelect.open();
      }
    },
    changeColor(row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
      var pm={ProductId:row.ProductId,ColorId:row.ColorId}
      if(row.PropertyId){
        pm.PropertyId=row.PropertyId;
      }   
      if(this.data.WarehouseId){
        pm.WarehouseId=this.data.WarehouseId;
      }
      this.pdApi.stockInfo(pm).then((res)=>{
        if(res.Code==0){
          row.ExistQuantity=res.Data.AvailableQuantity;
          row.StockQuantity=res.Data.StockQuantity;
        }
  
      });
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1;
      if (!Number(row.PuQuantity)) {
        this.$message.warning("请先填写数量");
        return true;
      }
      return false;
    },

    changeQuantity(data, row, index) {
      if(data=='-' || data== '.' || data==''){
          return
      }   
      data = Number(this.getQuantity(data));
      row.PuQuantity = data;
      if (row.T == 3) this.tableList[index].T = 1;
      if(this.data.MinusEntry){
            row.PuQuantity > 0 ? row.PuQuantity=0-row.PuQuantity  :  row.PuQuantity
            row.Quantity2 > 0 ? row.Quantity2=0-row.Quantity2 : row.Quantity2;
            data = data > 0 ? 0 - data : data;
      }else{
             row.PuQuantity=Math.abs(row.PuQuantity) 
            row.Quantity2=Math.abs(row.Quantity2) 
            data = Math.abs(data)
      }
      if(row.Units.length>0){
        if(row.IsMain){
          row.Quantity2= this.getQuantity(row.PuQuantity / Number(row.Rate));
        }else{
          row.Quantity2 = this.getQuantity(row.PuQuantity * Number(row.Rate))
        }
      }else{
        row.Quantity2=row.PuQuantity
      }
     // 金额
     if (Number(row.Price) ) {
        let Amount = Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
        this.tableList[index].Amount = Amount.toFixed(2);
      }

       // 税额
     if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit.toFixed(2);
      }

      // 含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice)
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0)   + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }

     
      
      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price))  * Number(data);
        this.tableList[index].DiscountAmount = DiscountAmount.toFixed(2);
      }
    },
    getChangeQuantity(data, row, index) {
      if (row.PuQuantity === '' || row.PuQuantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if(row.IsMain){
            row.PuQuantity= this.getQuantity(row.Quantity2 * Number(row.Rate));
          }else{
            row.PuQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate));
          }
        }
      }
    },
    // 数量2
    // changeQuantity2(row, index) {
    //   // console.log("输出", row.UnitChangeType);
    //   if (this.optionList.length === 0) return (row.PuQuantity = row.Quantity2);

    //   if (Number(row.Amount) != 0) row.Price2 = row.Amount * row.Quantity2;
    //   if (this.optionList.length > 0) {
    //     if (row.UnitChangeType == 0) {
    //       // console.log("执行");
    //       row.PuQuantity = row.Quantity2 / row.Rate;
    //       return this.changeQuantity(row.PuQuantity, row, index);
    //     }
    //     if (row.UnitChangeType == 1) {
    //       return (row.Rate = row.Quantity2 / row.PuQuantity);
    //     }
    //   }
    // },
    // 报价
    changeQuotedPrice(row, index) {

      if (row.T === 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice  
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price);

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.PuQuantity ?? 0);
      this.tableList[index].Amount = Amount.toFixed(2);

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price))  * Number(row.PuQuantity);
        this.tableList[index].DiscountAmount = DiscountAmount.toFixed(2);
      }

      // 税额
     if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.PuQuantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit.toFixed(2);
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0)  + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index,   "Discount")) return;  
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice  
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price);

      
       //修改金额
       let Amount = Number(row.Price ?? 0) * Number(row.PuQuantity ?? 0);
      this.tableList[index].Amount = Amount.toFixed(2);

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price))  * Number(row.PuQuantity);
        this.tableList[index].DiscountAmount = DiscountAmount.toFixed(2);
      }

      // 税额
     if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.PuQuantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit.toFixed(2);
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0)  + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }

      // if(row && Number(row.QuotedPrice)) row.TaxPrice
      // row.DiscountAmount = row.QuotedPrice * (1 - data.Discount / 100);
    },
    // 单价
    changePrice(row, index) {
      if (this.validInput(row, index, "Price")) return;

      row.Price = this.getPrice(row.Price);

      let quantityNum = 0;
      if(row.Units.length === 0){
        quantityNum=row.PuQuantity
      }else{
        if(row.IsMain){
          quantityNum=row.PuQuantity
        }else{
          quantityNum=row.Quantity2
        }
      }
      row.quantityNum = quantityNum;


      let rate = null;

      if(row.QuotedPrice == 0 || row.QuotedPrice == null || row.QuotedPrice == ""){
        
        rate = this.tableList[index].Discount / 100;
        if(rate === 1){
          row.QuotedPrice = row.Price;
        }else{
          row.QuotedPrice = parseFloat((row.Price * row.Discount).toFixed(2)) 
        }
      }else{ 
        rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
        this.tableList[index].Discount = parseFloat((rate ).toFixed(2)) ;
      }

      row.changeMode = 1;

      // 修改单价
      let equation = null;
      if(row.Discount == 100){
        equation = Number(row.QuotedPrice)
      }else{
        equation = row.Price
      }

      // 金额
      if (Number(row.quantityNum)) {
        console.log("row.quantityNum",row.quantityNum)
        let Amount = equation * Number(row.quantityNum) ;
        console.log("equation",equation)
        this.tableList[index].Amount = Amount.toFixed(2);
      }

      // 修改含税单价
      let TaxPrice = equation * (100 + Number(row.TaxRate) ) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

      // this.changeDiscount(row, index);
      
      if (Number(row.QuotedPrice)) {
       // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
        // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - equation)  * row.quantityNum;
          
        this.tableList[index].DiscountAmount =  DiscountAmount.toFixed(2);
        
      }
      if (Number(row.TaxRate)) {

        let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : TaxLimit.toFixed(2);
        // this.changeTaxRate(row, index);
      }
      
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, "TaxRate")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      row.TaxRate = this.getIinvexchrate(row.TaxRate)
      // 修改税额
      let TaxLimit = Number(row.Price ?? 0) * Number(row.PuQuantity) * ((row.TaxRate ?? 0) / 100)
      this.tableList[index].TaxLimit = TaxLimit.toFixed(2);

      // 修改含税单价
      let TaxPrice = row.Price * (100 + Number(row.TaxRate) ) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      
      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      this.tableList[index].TaxAmount = TaxAmount.toFixed(2);

    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, "TaxPrice")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = row.TaxPrice / (1+ row.TaxRate / 100)
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
      this.tableList[index].Discount = parseFloat((rate ).toFixed(2));

      // 修改金额
      let Amount = Number(row.Price) * Number(row.PuQuantity) * (row.Discount / 100) 
      this.tableList[index].Amount = Amount.toFixed(2);

       // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price))  * row.PuQuantity;
      this.tableList[index].DiscountAmount =  DiscountAmount.toFixed(2);

      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.PuQuantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : TaxLimit.toFixed(2);
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, "TaxLimit")) return;
      // if(Number(row.PuQuantity)) this.tableList[index].TaxAmount

      if (row.T == 3) this.tableList[index].T = 1;

      

      if(row.changeMode === 0 || row.changeMode == null){
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit);
        this.tableList[index].Amount = Amount.toFixed(2);

        // 修改单价
        let Price = Number(row.Amount) / Number(row.PuQuantity)
        this.tableList[index].Price = this.getPrice(Price);

        // this.changePrice(row, index)

        // 修改折扣率
        let rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
        this.tableList[index].Discount = parseFloat((rate ).toFixed(2)) ;

        // 修改含税单价
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate ?? 0) ) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - Number(row.Price))  * row.PuQuantity;
        this.tableList[index].DiscountAmount = DiscountAmount.toFixed(2);

        // 修改含税金额
        if (Number(row.TaxLimit) || Number(row.Amount)) {
          let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
          this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
        }



      }else{
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.PuQuantity);
        this.tableList[index].TaxPrice = this.getPrice(TaxPrice);
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, "Amount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = Number(row.Amount) / Number(row.PuQuantity) 
      this.tableList[index].Price = this.getPrice(Price);

      // 修改报价
      if(Number(this.tableList[index].Discount) === 100){
        row.QuotedPrice = this.tableList[index].Price;
      }

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
      this.tableList[index].Discount = parseFloat((rate ).toFixed(2));

       // 折扣金额
       let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - Number(row.Price))  * row.PuQuantity;
        this.tableList[index].DiscountAmount =  DiscountAmount.toFixed(2);

      // this.changePrice(row, index)
       // 修改含税单价
      if(Number(row.TaxRate)){
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      }
      
      // 修改税额
      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.PuQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : TaxLimit.toFixed(2);
      // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, "TaxAmount")) return;

      if (row.T == 3) this.tableList[index].T = 1;

      row.changeMode = 0;

      // 修改金额
      let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
      this.tableList[index].Amount = Amount.toFixed(2);


      // 修改单价
      let Price = Number(row.Amount) / Number(row.PuQuantity)
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
      this.tableList[index].Discount = parseFloat((rate ).toFixed(2));

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.PuQuantity)
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);


       // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price))  * row.PuQuantity;
      this.tableList[index].DiscountAmount =DiscountAmount.toFixed(2);

    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, "DiscountAmount")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      
      // 修改单价
      let Price = row.QuotedPrice - (row.DiscountAmount / row.PuQuantity)
      this.tableList[index].Price = this.getPrice(Price);

      // 修改折扣率

      let rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
      this.tableList[index].Discount = parseFloat((rate ).toFixed(2));

      // 金额
      let Amount = Number(row.Price) * Number(row.PuQuantity) * (Number(row.Discount) / 100);
      this.tableList[index].Amount = Amount.toFixed(2);

      // 修改含税单价
      if(Number(row.TaxRate)){
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate) ) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice);
      }
      
      // 修改税额
      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.PuQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : TaxLimit.toFixed(2);
      // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      }
    },
    // 单价弹窗
    renderHeader(h, { column }) {
      return h("div", [
        h("span", column.label),
        h("i", {
          class: "el-icon-s-order",
          style: "font-size:14px;cursor: pointer;",
          on: {
            click: this.openSales,
          },
        }),
      ]);
    },
    openPrint() {
      this.columnkey = saleList.Data.map((i) => i.tableName);
      this.columns = saleList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = saleList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName],
        });
      }, []);
      this.$refs.printDialog.open();
      s;
    },
    save(type = 0) {
      this.$refs.ruleForm.validate((valid) => { 
        if (!valid) return false;
        if(this.data.PayId === 2 && this.data.ReceiptAmount === 0){
          this.$message.warning("付款方式为全额现结时，现结金额必填");
          return
        }
        if(this.data.TradeUnitId==null || this.data.TradeUnitId==0)  return this.$message.warning("供应商不能为空");
        const Product = JSON.parse(JSON.stringify(this.data.Products));
        const TableList = JSON.parse(JSON.stringify(this.tableList));
        if(this.deleteDateList.length>0) this.data.Pays=this.data.Pays.concat(...this.deleteDateList)

        var btId = 0;
        var obj = this.businessTypeList.find(x => x.BusinessType == "采购退货");
        if(obj) btId = obj.BusinessTypeId;

        // 清除没有产品的数据
        this.tableList = this.tableList.filter((i) => i.ProductId != 0);
        for(let i=0;i<=this.tableList.length-1;i++){
          if(this.data.BusinessTypeId == btId && btId) {
            if (this.tableList[i].Amount > 0) {
              this.$message({ type: "warning", message: "金额不能大于0" });
              return;
            }
          } else {
            if (this.tableList[i].Amount < 0) {
              this.$message({ type: "warning", message: "金额不能小于0" });
              return;
            }
          }
          if(this.tableList[i].PuQuantity ==null || this.tableList[i].PuQuantity ==0)  return this.$message.warning("数量不能为空并且不为0");
          if((this.tableList[i].UnitId2 ==null || this.tableList[i].UnitId2 == 0) && this.tableList[i].UnitType==1)  return this.$message.warning("计量单位2不能为空");
          if(this.tableList[i].UseColor && (this.tableList[i].ColorId === 0 || this.tableList[i].ColorId == null)){
            this.$message.error(`存货${this.tableList[i].ProductName}未填写颜色`)
            return;
          }
          if(this.tableList[i].UseProcess && (this.tableList[i].PropertyId === 0 || this.tableList[i].PropertyId == null)){
            this.$message.error(`存货${this.tableList[i].ProductName}未填写属性`)
            return;
          }
        }
        // if (this.tableList.filter((i) => i.DeliveryDate == "").length !== 0)
        //   return this.$message.warning("交货日期不能为空");
        // //
       
        if (this.data.Products.length > 0) {
          let delIds = this.tableList.map((item) => item.ProductId);
          let delList = this.data.Products.reduce((arr, item) => {
            if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
            return arr;
          }, []);

          let addIds = this.data.Products.map((item) => item.ProductId);
          console.log('addIds', addIds)
          addIds = addIds.filter(item => {
            return item != null
          })
          let addList = [];
          addList = this.tableList.reduce((arr, item) => {
            if (!addIds.includes(item.ProductId)) arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.data.Products.filter((i) => i.T == 1);
          console.log('addList', addList)
          console.log('delList', delList)
          console.log('updateList', updateList)

          this.data.Products = [...addList, ...delList, ...updateList];
        } else {
          this.data.Products = this.tableList;
          this.data.Products.forEach(item => {
            item.ColorId = item.ColorId ?  item.ColorId : 0;
          })
        } 

        this.data.Products.forEach(item=>{
          if(item.WarehouseId==null)item.WarehouseId=0
        })
        //
        this.data.Pays = this.data.Pays.filter((i) =>(i.T || i.T ==0 ) && i.SettleId );
        this.data.DeliveryDate = this.data.DocDate;
        console.log("保存前", this.data);
        // var data = this.$commonJs.obj.removeNullKey(this.data);
       if(this.data.InvoiceTypeId==null) this.data.InvoiceTypeId = 0;
       if(this.data.BusinessTypeId==null) this.data.BusinessTypeId = 0;
       var sub = { ...this.data };
       sub.Products.forEach(e => {
         if(!e.PropertyId) e.PropertyId = 0;
        e.SourceGoodsId= e.SourceDtsId
       })
        // 等于空设置为0
        sub.Products.forEach(item => {
          Object.keys(item).forEach(key => {
            if (item[key] == null && key !== 'LineAbortDate' && key !== 'DeliveryDate' && key !== 'ExpiringDate') {
              item[key] = 0;
            }
          })
        })
        this.api.save(sub).then((res) => {
          if (res.Code === 0) {
            const id = res.Data === 0 ? this.data.DocId : res.Data;
            this.isSave = true;
            this.is_orderUpdateStatus = false;
            if (!this.data.DocId) this.data.DocId = id;
            this.editOrder(id, type);
            if(type !== 1){
                this.$message.success("保存成功");
              }
          } else {
            this.tableList = TableList;
            this.ProductModels = Product;
            this.data.Products = Product
            this.$message.error(res.Msg);
          }
        }).catch(err => {
          this.tableList = TableList;
          this.ProductModels = Product;
          this.data.Products = Product
          // this.$message.error(res.Msg);
        })
      });
    },
    changeProperty(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }
      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];
      row.PropertyName = item.PropertyName;
      var pm={ProductId:row.ProductId,PropertyId:row.PropertyId}
      if(row.ColorId){
        pm.ColorId=row.ColorId;
      }   
      if(this.data.WarehouseId){
        pm.WarehouseId=this.data.WarehouseId;
      }
      this.pdApi.stockInfo(pm).then((res)=>{
        if(res.Code==0){
          row.ExistQuantity=res.Data.AvailableQuantity;
          row.StockQuantity=res.Data.StockQuantity;
        }
  
      });
    },
    editT(row){
      if(row.T !== 0){
        row.T = 1;
      }
    },
    addList() {
      this.tableList.push({
        T: 0,
        DocProductId: 0,
        DocId: 0,
        SourceGoodsId: 0,
        BarCode: "",
        PuUnitId: 0,
        Discount: 100,
        TaxRate: null,
        Price: null,
        PuQuantity: null,
        BatchNo: "",
        TaxAmount: null,
        Amount: null,
        // AddTime: "",
        UnitId2: 0,
        Quantity2: null,
        WarehouseId: 0,
        StockInQuantity: null,
        StockInQuantity2: null,
        InvoiceQuantity: null,
        InvoiceQuantity2: null,
        CostQuantity: null,
        RefundQuantity: null,
        RefundQuantity2: null,
        CdRefundQuantity: null,
        CdRefundQuantity2: null,
        PricingType: 0,
        SourceOrderId: 0,
        SourceOrderNo: "",
        PuOrderId: 0,
        PuOrderNo: "",
        StockQuantity: null,
        ExistQuantity: null,
        ReceivableQuantity: null,
        ReceivableQuantity2: null,
        DocNo: "",
        DocType: 0,
        DocDate: "",
        TradeUnitId: 0,
        SourceType: 0,
        IsGift: false,
        TaxLimit: null,
        TaxPrice: null,
        QuotedPrice: null,
        SettlementAmount: null,
        BaseQuantity: null,
        SubQuantity: null,
        TradeUnitNo: "",
        TradeUnitName: "",
        ColorId: null,
        ColorName: "",
        Price2: null,
        DeliveryDate: "",
        ProductId: 0,
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        WarehouseNo: "",
        WarehouseName: "",
        Remark: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   // margin-top: 10px;
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
